export function saveBookingProcessToStorage({ product_type }) {
  window.localStorage.setItem(
    "booking_process",
    JSON.stringify({ product_type })
  );
}

export function loadBookingProcessFromStorage() {
  const data = window.localStorage.getItem("booking_process");

  if (typeof data !== "undefined" && data) {
    const json_data = JSON.parse(data);

    if (!json_data.product_type) {
      return null;
    }
    return json_data;
  } else {
    return null;
  }
}

export const clearBookingProcessStorage = () => {
  window.localStorage.removeItem("booking_process");
};
